/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Steep_Elegant_Vulture_TrimInputs */

const fr_steep_elegant_vulture_trim = /** @type {(inputs: Steep_Elegant_Vulture_TrimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+6 mois`)
};

/**

* @param {Steep_Elegant_Vulture_TrimInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const steep_elegant_vulture_trim = /** @type {((inputs?: Steep_Elegant_Vulture_TrimInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Steep_Elegant_Vulture_TrimInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_steep_elegant_vulture_trim(inputs)
});